import { render, staticRenderFns } from "./SpecificArticle.vue?vue&type=template&id=3f94e0a4&scoped=true&"
import script from "./SpecificArticle.vue?vue&type=script&lang=js&"
export * from "./SpecificArticle.vue?vue&type=script&lang=js&"
import style0 from "./SpecificArticle.vue?vue&type=style&index=0&id=3f94e0a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f94e0a4",
  null
  
)

export default component.exports